/*
 * Made with ♥ by Mister Topdesign
 * Product leasing estimate, modal accessibility and inquiry synchronization.
 */
(function () {
  'use strict';

  var mtProviders = [
    {
      name: 'BusinessBike',
      percent: 6,
      url: 'https://www.businessbike.de/de/rechner/',
      image: 'https://cdn.shopify.com/s/files/1/0875/3794/2863/files/BusinessBike_pos_BLUE_RED_BLUE_rgb_Kopie.png?v=1769679820'
    },
    {
      name: 'Deutsche Dienstrad',
      percent: 3,
      url: 'https://www.deutsche-dienstrad.de/jetzt-berechnen',
      image: 'https://cdn.shopify.com/s/files/1/0875/3794/2863/files/dd-logo-farbig.jpg?v=1762890893'
    },
    {
      name: 'Lease a Bike',
      percent: 5,
      url: 'https://www.lease-a-bike.de/leasing-rechner',
      image: 'https://cdn.shopify.com/s/files/1/0875/3794/2863/files/Wordmark__leaseabike_transparent_Kopie.png?v=1769679581'
    },
    {
      name: 'Bikeleasing',
      percent: 6,
      url: 'https://bikeleasing.de/leasingrechner',
      image: 'https://i0.wp.com/unserladen.radhalle.com/wp-content/uploads/2024/07/Bikeleasing_Logo_D_Balken_gruen-e1720081226642.jpg?w=1600&ssl=1'
    },
    {
      name: 'EURORAD',
      percent: 6,
      url: 'https://www.eurorad.de/leasingrechner/',
      image: 'https://cdn.shopify.com/s/files/1/0875/3794/2863/files/ER_Logo01_twotone_4x_72f9f29a-f817-4928-b844-a236495a2a79.png?v=1762890924'
    },
    {
      name: 'JobRad',
      percent: 6,
      url: 'https://www.jobrad.org/arbeitnehmer/ersparnis-berechnen',
      image: 'https://cdn.shopify.com/s/files/1/0875/3794/2863/files/JobRad_Logo_Anthrazit_RGB_4x_9c6b299a-1603-456a-aaf2-1b09d1f5df12_Kopie.png?v=1769679580'
    }
  ];
  /* Made with ♥ by Mister Topdesign | Anbieter ohne pauschale Rate */
  var mtOtherProvider = { name: 'Andere Leasinganbieter', other: true };

  /* Made with ♥ by Mister Topdesign | einheitliches Produktdesign auch ohne Leasing */
  var mtTaxOriginalContent = new WeakMap();
  var mtProductRoot = document.querySelector('.product__info-container');
  var mtProductDesktopQuery = window.matchMedia('(min-width: 990px)');

  if (mtProductRoot) {
    document.body.classList.add('mt-product-page--enhanced');
  }

  function mtInitializeUniversalProductPage() {
    if (!mtProductRoot) return;
    mtInitializeUniversalProductDescription();
    mtInitializeDeliveryService();
    mtSyncThumbnailAlignment();
    mtInitializePurchaseArea();
    mtSyncProductStockState();
    mtSyncProductQuestionForm();
    mtInitializeComplementaryProducts();
    mtSyncResponsiveProductSections();
  }

  var mtModal = document.getElementById('mt-leasing-modal');

  /* Made with ♥ by Mister Topdesign | nach abgeschlossenem Variantenwechsel synchronisieren */
  if (mtProductRoot && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (mtEvent) {
      var mtProductInfo = mtProductRoot.closest('product-info');
      if (!mtEvent?.data || !mtProductInfo
        || mtEvent.data.sectionId !== mtProductInfo.dataset.section) return;

      mtInitializeUniversalProductPage();
      if (!mtModal) return;

      mtInitializeTriggers();
      mtSyncMobileBuybar();

      if (!mtModal.hidden) {
        var mtLeasingTrigger = document.querySelector('[data-mt-open-leasing]');
        if (mtLeasingTrigger) {
          mtUpdateProductOutputs(mtReadProduct(mtLeasingTrigger));
          mtUpdateResult(mtCurrentProvider);
        }
      }
    });
  }

  if (!mtModal) {
    mtInitializeUniversalProductPage();

    if (typeof mtProductDesktopQuery.addEventListener === 'function') {
      mtProductDesktopQuery.addEventListener('change', mtSyncResponsiveProductSections);
    } else {
      mtProductDesktopQuery.addListener(mtSyncResponsiveProductSections);
    }

    var mtUniversalRefreshQueued = false;
    var mtUniversalObserver = new MutationObserver(function (mtMutations) {
      var mtRelevantSelector = [
        'product-recommendations',
        '.complementary-products__container',
        'product-component',
        '.product-form__submit',
        '.shopify-payment-button',
        '.rh-eta-pill',
        '.rh-shipfree-pill',
        'variant-selects',
        'variant-radios',
        '.icon-with-text--horizontal'
      ].join(', ');

      var mtNeedsRefresh = mtMutations.some(function (mtMutation) {
        return Array.from(mtMutation.addedNodes).some(function (mtNode) {
          return mtNode.nodeType === 1 && (
            mtNode.matches?.(mtRelevantSelector)
            || mtNode.querySelector?.(mtRelevantSelector)
          );
        });
      });

      if (!mtNeedsRefresh || mtUniversalRefreshQueued) return;
      mtUniversalRefreshQueued = true;
      window.requestAnimationFrame(function () {
        mtUniversalRefreshQueued = false;
        mtInitializeUniversalProductPage();
      });
    });

    mtUniversalObserver.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('shopify:section:load', mtInitializeUniversalProductPage);
    return;
  }

  var mtPanel = mtModal.querySelector('.mt-leasing-modal__panel');
  var mtProvidersContainer = document.getElementById('mt-leasing-providers');
  var mtRequestForm = document.getElementById('mt-leasing-request-form');
  if (mtRequestForm) mtRequestForm.noValidate = true;
  var mtLastFocus = null;
  var mtCurrentProduct = null;
  var mtCurrentProvider = mtProviders[0];
  var mtOverlay = mtModal.querySelector('.mt-leasing-modal__overlay');
  var mtWizard = document.querySelector('[data-mt-wizard]');
  var mtWizardTeaser = document.querySelector('[data-mt-wizard-teaser]');
  var mtWizardStepsWrap = document.querySelector('[data-mt-wizard-steps]');
  var mtWizardSteps = mtWizard ? Array.from(mtWizard.querySelectorAll('[data-mt-wizard-step]')) : [];
  var mtWizardBack = document.querySelector('[data-mt-wizard-back]');
  var mtWizardProgressLabel = document.getElementById('mt-leasing-wizard-progress-label');
  var mtWizardProgressBar = document.getElementById('mt-leasing-wizard-progress-bar');
  var mtWizardIndex = 0;

  if (mtOverlay) {
    mtOverlay.addEventListener('click', function (event) {
      event.preventDefault();
      mtClose();
    });
  }

  /* Made with ♥ by Mister Topdesign */
  function mtWizardFirstName() {
    var mtNameField = document.getElementById('mt-leasing-name');
    var mtName = mtNameField ? mtNameField.value.trim() : '';
    return mtName ? mtName.split(/\s+/)[0] : 'du';
  }

  function mtWizardSyncPersonalization() {
    var mtFirstName = mtWizardFirstName();
    var mtEmail = document.getElementById('mt-leasing-email');
    var mtPostcode = document.getElementById('mt-leasing-postcode');
    var mtSize = document.getElementById('mt-leasing-size');
    var mtPhone = document.getElementById('mt-leasing-phone');

    document.querySelectorAll('[data-mt-wizard-name-output]').forEach(function (mtOutput) {
      mtOutput.textContent = mtFirstName;
    });

    document.querySelectorAll('[data-mt-wizard-review-email]').forEach(function (mtOutput) {
      mtOutput.textContent = mtEmail && mtEmail.value.trim() ? mtEmail.value.trim() : '—';
    });

    document.querySelectorAll('[data-mt-wizard-review-phone]').forEach(function (mtOutput) {
      mtOutput.textContent = mtPhone && mtPhone.value.trim() ? mtPhone.value.trim() : '—';
    });

    document.querySelectorAll('[data-mt-wizard-review-postcode]').forEach(function (mtOutput) {
      mtOutput.textContent = mtPostcode && mtPostcode.value.trim() ? mtPostcode.value.trim() : '—';
    });

    document.querySelectorAll('[data-mt-wizard-review-size]').forEach(function (mtOutput) {
      mtOutput.textContent = mtSize && mtSize.value.trim() ? mtSize.value.trim() : '—';
    });

    var mtProviderDetail = mtModal.querySelector('[data-mt-wizard-review-provider-detail]');
    var mtActiveGroup = mtModal.querySelector('[data-mt-provider-fields]:not([hidden])');
    var mtActiveField = mtActiveGroup && mtActiveGroup.querySelector('[data-mt-provider-required]:not([disabled])');
    if (mtProviderDetail) {
      mtProviderDetail.hidden = !mtActiveField || Boolean(mtCurrentProvider?.other);
      if (mtActiveField && !mtCurrentProvider?.other) {
        var mtDetailLabel = mtActiveField.closest('.mt-leasing-field')?.querySelector('label');
        var mtDetailValue = mtActiveGroup.querySelector('[data-mt-provider-other-name]:not([disabled])') || mtActiveField;
        mtProviderDetail.querySelector('[data-mt-wizard-review-provider-label]').textContent = mtDetailLabel ? mtDetailLabel.textContent.replace('*', '').trim() : 'Zusatzangabe';
        mtProviderDetail.querySelector('[data-mt-wizard-review-provider-value]').textContent = mtDetailValue.value.trim() || '—';
      }
    }
  }

  /* Made with ♥ by Mister Topdesign | Modal-Schritte unter dem festen Kopf ausrichten */
  function mtWizardScrollIntoView() {
    if (!mtPanel || !mtWizard) return;

    window.requestAnimationFrame(function () {
      var mtHeader = mtModal.querySelector('.mt-leasing-modal__header');
      var mtHeaderHeight = mtHeader ? mtHeader.getBoundingClientRect().height : 0;
      var mtTargetTop = Math.max(
        0,
        mtPanel.scrollTop + mtWizard.getBoundingClientRect().top - mtPanel.getBoundingClientRect().top - mtHeaderHeight - 16
      );
      mtPanel.scrollTo({
        top: mtTargetTop,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    });
  }

  function mtWizardShowStep(index, shouldFocus) {
    if (!mtWizardSteps.length) return;

    mtWizardIndex = Math.max(0, Math.min(index, mtWizardSteps.length - 1));
    mtWizardSyncPersonalization();

    mtWizardSteps.forEach(function (mtStep, mtIndex) {
      mtStep.hidden = mtIndex !== mtWizardIndex;
    });

    if (mtWizardProgressLabel) {
      mtWizardProgressLabel.textContent = 'Schritt ' + (mtWizardIndex + 1) + ' von ' + mtWizardSteps.length;
    }

    if (mtWizardProgressBar) {
      mtWizardProgressBar.style.width = (((mtWizardIndex + 1) / mtWizardSteps.length) * 100) + '%';
    }

    if (mtWizardBack) {
      mtWizardBack.hidden = false;
      mtWizardBack.setAttribute(
        'aria-label',
        mtWizardIndex === 0 ? 'Zurück zur Leasingberechnung' : 'Einen Schritt zurück'
      );
    }

    mtWizardScrollIntoView();

    if (shouldFocus !== false) {
      window.requestAnimationFrame(function () {
        var mtQuestion = mtWizardSteps[mtWizardIndex].querySelector('.mt-leasing-wizard__question');
        if (mtQuestion) mtQuestion.focus({ preventScroll: true });
      });
    }
  }

  function mtWizardValidateStep(index) {
    var mtCurrentStep = mtWizardSteps[index === undefined ? mtWizardIndex : index];
    if (!mtCurrentStep) return false;

    var mtFields = Array.from(mtCurrentStep.querySelectorAll('input:not([disabled]), textarea:not([disabled]), select:not([disabled])'));
    for (var mtIndex = 0; mtIndex < mtFields.length; mtIndex += 1) {
      if (mtFields[mtIndex].required && !mtFields[mtIndex].value.trim()) {
        mtFields[mtIndex].setCustomValidity('Bitte fülle dieses Pflichtfeld aus.');
      } else {
        mtFields[mtIndex].setCustomValidity('');
      }
      if (!mtFields[mtIndex].checkValidity()) {
        if (index !== undefined && index !== mtWizardIndex) mtWizardShowStep(index, false);
        mtFields[mtIndex].reportValidity();
        mtFields[mtIndex].focus();
        return false;
      }
    }

    return true;
  }

  function mtWizardStart(resetStep) {
    if (!mtWizard || !mtWizardTeaser) return;

    mtWizardTeaser.hidden = true;
    mtWizard.hidden = false;
    mtModal.classList.add('mt-leasing-modal--wizard-active');
    if (mtWizardStepsWrap) mtWizardStepsWrap.hidden = false;
    mtWizardShowStep(resetStep === false ? mtWizardIndex : 0, true);
  }

  function mtWizardReturnToTeaser() {
    if (!mtWizard || !mtWizardTeaser) return;

    mtWizard.hidden = true;
    mtWizardTeaser.hidden = false;
    mtModal.classList.remove('mt-leasing-modal--wizard-active');
    mtWizardIndex = 0;

    window.requestAnimationFrame(function () {
      /* Made with ♥ by Mister Topdesign | nach dem Formular wieder die Anbieterauswahl zeigen */
      mtPanel.scrollTo({ top: 0, behavior: 'auto' });
      var mtStart = document.querySelector('[data-mt-wizard-start]');
      if (mtStart) mtStart.focus({ preventScroll: true });
    });
  }

  function mtWizardNext() {
    if (!mtWizardValidateStep()) return;
    if (mtWizardIndex < mtWizardSteps.length - 1) {
      mtWizardShowStep(mtWizardIndex + 1, true);
    }
  }

  function mtWizardPreparePostedStatus(mtStatus) {
    if (!mtStatus) return;

    mtWizardStart(true);

    if (mtStatus.hasAttribute('data-mt-leasing-success')) {
      if (mtWizardStepsWrap) mtWizardStepsWrap.hidden = true;
      if (mtWizardProgressLabel) mtWizardProgressLabel.textContent = 'Anfrage gesendet';
      if (mtWizardProgressBar) mtWizardProgressBar.style.width = '100%';
      if (mtWizardBack) mtWizardBack.hidden = true;
    }
  }

  function mtMoney(value, currency, locale) {
    return new Intl.NumberFormat(locale || 'de-DE', {
      style: 'currency',
      currency: currency || 'EUR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(Number(value) || 0);
  }

  function mtNetFactor(price) {
    if (price < 2000) return 0.70;
    if (price >= 5000) return 0.58;
    return 0.62;
  }

  function mtCalculate(price, percent) {
    var mtFee = price * (percent / 100);
    var mtGrossMonthly = (price + mtFee) / 36;
    var mtEstimatedNet = mtGrossMonthly * mtNetFactor(price);

    return {
      fee: Number(mtFee.toFixed(2)),
      grossMonthly: Number(mtGrossMonthly.toFixed(2)),
      estimatedNet: Number(mtEstimatedNet.toFixed(2))
    };
  }

  function mtReadLocalizedPrice(text) {
    var mtValue = String(text || '').replace(/[^0-9.,]/g, '');
    if (!mtValue) return 0;
    if (mtValue.includes(',')) {
      mtValue = mtValue.replace(/\./g, '').replace(',', '.');
    }
    return Number.parseFloat(mtValue) || 0;
  }

  /* Made with ♥ by Mister Topdesign */
  function mtReadSelectedVariant() {
    var mtVariantIdInput = document.querySelector(
      '.product__info-container product-form input[name="id"], '
      + '.product__info-container form[action*="/cart/add"] input[name="id"]'
    );
    var mtSelectedInputs = Array.from(document.querySelectorAll(
      '.product__info-container variant-radios input:checked, '
      + '.product__info-container variant-selects input:checked'
    ));
    var mtSelectedSelects = Array.from(document.querySelectorAll(
      '.product__info-container variant-selects select'
    ));

    var mtOptions = mtSelectedInputs.map(function (mtInput) {
      var mtName = String(mtInput.name || 'Variante')
        .replace(/[\r\n]+/g, ' ')
        .replace(/-\d+\s*$/, '')
        .trim();
      return mtName + ': ' + String(mtInput.value || '').trim();
    });

    mtSelectedSelects.forEach(function (mtSelect) {
      var mtName = String(mtSelect.name || 'Variante')
        .replace(/[\r\n]+/g, ' ')
        .replace(/-\d+\s*$/, '')
        .trim();
      var mtValue = mtSelect.options[mtSelect.selectedIndex] && mtSelect.options[mtSelect.selectedIndex].text;
      if (mtValue) mtOptions.push(mtName + ': ' + mtValue.trim());
    });

    return {
      id: mtVariantIdInput ? String(mtVariantIdInput.value || '') : '',
      label: mtOptions.join(' · ')
    };
  }

  function mtReadProduct(trigger) {
    var mtPrice = Number.parseFloat(trigger.getAttribute('data-product-price') || '');
    if (!mtPrice) {
      var mtPriceNode = document.querySelector('.product__info-container .price-item--regular, .product__info-container .price-item--sale');
      mtPrice = mtReadLocalizedPrice(mtPriceNode && mtPriceNode.textContent);
    }

    var mtSkuNode = document.querySelector('.product__info-container .caption-with-letter-spacing');
    var mtSku = (mtSkuNode && mtSkuNode.textContent || '').replace(/^\s*SKU:\s*/i, '').trim();

    var mtVariant = mtReadSelectedVariant();

    return {
      title: trigger.getAttribute('data-product-title') || mtModal.getAttribute('data-mt-product-title') || document.title,
      sku: mtSku || mtModal.getAttribute('data-mt-product-sku') || '',
      price: mtPrice || Number.parseFloat(mtModal.getAttribute('data-mt-product-price') || '0'),
      currency: trigger.getAttribute('data-currency') || 'EUR',
      locale: (trigger.getAttribute('data-locale') || 'de-DE').replace('_', '-'),
      url: window.location.origin + window.location.pathname,
      variantId: mtVariant.id,
      variantLabel: mtVariant.label
    };
  }

  function mtLowestEstimate(product) {
    return mtProviders.reduce(function (lowest, provider) {
      var estimate = mtCalculate(product.price, provider.percent).estimatedNet;
      return estimate < lowest ? estimate : lowest;
    }, Number.POSITIVE_INFINITY);
  }

  function mtCardMarkup(product) {
    var mtRate = mtLowestEstimate(product);

    return '' +
      '<span class="mt-product-leasing-card__badge">BIKELEASING</span>' +
      '<span class="mt-product-leasing-card__content">' +
        '<span class="mt-product-leasing-card__rate">ab <strong>' +
          mtMoney(mtRate, product.currency, product.locale) +
        '</strong> / Monat</span>' +
        '<span class="mt-product-leasing-card__note">36 Monate · unverbindliche Schätzung</span>' +
      '</span>' +
      '<span class="mt-product-leasing-card__action">Rate berechnen <span aria-hidden="true">→</span></span>';
  }

  function mtDecorateTrigger(trigger) {
    var mtProduct = mtReadProduct(trigger);

    trigger.className = 'mt-product-leasing-card';
    trigger.setAttribute('href', '#mt-leasing-modal');
    trigger.setAttribute('data-mt-open-leasing', '');
    trigger.setAttribute('aria-controls', 'mt-leasing-modal');
    trigger.setAttribute('aria-haspopup', 'dialog');
    trigger.setAttribute('aria-label', mtProduct.title + ' – Bikeleasingrate berechnen');
    trigger.removeAttribute('data-open-leasing');
    trigger.innerHTML = mtCardMarkup(mtProduct);

    document.body.classList.add('mt-product-page--leasing');

    var mtTax = document.querySelector('.product__info-container > .product__tax');
    if (mtTax && trigger.previousElementSibling !== mtTax) {
      mtTax.insertAdjacentElement('afterend', trigger);
    }
  }

  function mtInitializeTriggers() {
    document.querySelectorAll('[data-open-leasing], [data-mt-open-leasing]').forEach(mtDecorateTrigger);
  }

  function mtSetText(id, value) {
    var mtElement = document.getElementById(id);
    if (mtElement) mtElement.textContent = value;
  }

  function mtSetValue(id, value) {
    var mtElement = document.getElementById(id);
    if (mtElement) mtElement.value = value;
  }

  /* Made with ♥ by Mister Topdesign | nur Felder des gewählten Anbieters sind aktiv und Pflicht */
  function mtSelectedProviderName() {
    if (!mtCurrentProvider?.other) return mtCurrentProvider?.name || '';
    var mtSelect = mtModal.querySelector('[data-mt-provider-other-select]');
    if (!mtSelect?.value) return 'Andere Leasinganbieter';
    if (mtSelect.value !== 'Andere') return mtSelect.value;
    var mtName = mtModal.querySelector('[data-mt-provider-other-name]')?.value.trim();
    return mtName || 'Andere Leasinganbieter';
  }

  function mtSyncProviderFields() {
    var mtRoot = mtModal.querySelector('[data-mt-provider-fields-root]');
    if (!mtRoot) return;
    var mtSelectedName = mtCurrentProvider?.name || '';
    var mtActiveGroup = null;
    mtRoot.querySelectorAll('[data-mt-provider-fields]').forEach(function (mtGroup) {
      var mtActive = mtGroup.getAttribute('data-mt-provider-fields') === mtSelectedName;
      mtGroup.hidden = !mtActive;
      if (mtActive) mtActiveGroup = mtGroup;
      mtGroup.querySelectorAll('input, select').forEach(function (mtField) {
        mtField.disabled = !mtActive;
        mtField.required = mtActive && mtField.hasAttribute('data-mt-provider-required');
        if (!mtActive) mtField.setCustomValidity('');
      });
    });
    mtRoot.hidden = !mtActiveGroup;
    var mtOtherSelect = mtRoot.querySelector('[data-mt-provider-other-select]');
    var mtOtherNameWrap = mtRoot.querySelector('[data-mt-provider-other-name-field]');
    var mtOtherName = mtRoot.querySelector('[data-mt-provider-other-name]');
    if (mtOtherNameWrap && mtOtherName) {
      var mtNeedsName = Boolean(mtActiveGroup && mtCurrentProvider.other && mtOtherSelect.value === 'Andere');
      mtOtherNameWrap.hidden = !mtNeedsName;
      mtOtherName.disabled = !mtNeedsName;
      mtOtherName.required = mtNeedsName;
    }
    mtSetValue('mt-leasing-form-provider', mtSelectedProviderName());
    mtSetText('mt-leasing-request-provider-output', mtSelectedProviderName());
    mtWizardSyncPersonalization();
  }

  function mtRenderProviders() {
    if (!mtProvidersContainer) return;
    mtProvidersContainer.innerHTML = '';

    mtProviders.forEach(function (provider, index) {
      var mtButton = document.createElement('button');
      mtButton.type = 'button';
      mtButton.className = 'mt-leasing-provider';
      mtButton.setAttribute('data-mt-provider-index', String(index));
      mtButton.setAttribute('aria-pressed', provider === mtCurrentProvider ? 'true' : 'false');
      mtButton.setAttribute('aria-label', 'Leasinganbieter ' + provider.name + ' auswählen');

      var mtLogo = document.createElement('span');
      mtLogo.className = 'mt-leasing-provider__logo';
      mtLogo.setAttribute('aria-hidden', 'true');
      mtLogo.style.backgroundImage = 'url("' + provider.image + '")';

      var mtCheck = document.createElement('span');
      mtCheck.className = 'mt-leasing-provider__check';
      mtCheck.setAttribute('aria-hidden', 'true');
      mtCheck.textContent = '✓';

      mtButton.appendChild(mtLogo);
      mtButton.appendChild(mtCheck);
      mtProvidersContainer.appendChild(mtButton);
    });

    var mtOtherButton = document.createElement('button');
    mtOtherButton.type = 'button';
    mtOtherButton.className = 'mt-leasing-provider mt-leasing-provider--other';
    mtOtherButton.setAttribute('data-mt-provider-other', '');
    mtOtherButton.setAttribute('aria-pressed', mtCurrentProvider === mtOtherProvider ? 'true' : 'false');
    mtOtherButton.textContent = 'Andere Leasinganbieter';
    mtProvidersContainer.appendChild(mtOtherButton);
  }

  function mtUpdateProductOutputs(product) {
    mtCurrentProduct = product;
    mtSetText('mt-leasing-purchase', mtMoney(product.price, product.currency, product.locale));
    mtSetText('mt-leasing-product-price-output', mtMoney(product.price, product.currency, product.locale));

    var mtTitle = mtModal.querySelector('[data-mt-product-title-output]');
    var mtSku = mtModal.querySelector('[data-mt-product-sku-output]');
    var mtPrice = mtModal.querySelector('[data-mt-product-price-output]');

    if (mtTitle) mtTitle.textContent = product.title;
    if (mtSku) mtSku.textContent = product.sku ? 'SKU: ' + product.sku : '';
    if (mtPrice) mtPrice.textContent = mtMoney(product.price, product.currency, product.locale);

    var mtVariantOutput = mtModal.querySelector('[data-mt-product-variant-output]');
    var mtVariantValue = mtVariantOutput && mtVariantOutput.querySelector('strong');
    if (mtVariantOutput) {
      mtVariantOutput.hidden = !product.variantLabel;
      if (mtVariantValue) mtVariantValue.textContent = product.variantLabel;
    }

    mtSetText('mt-leasing-request-product-output', product.title);
    mtSetValue('mt-leasing-form-variant-id', product.variantId || '');
    mtSetValue('mt-leasing-form-variant', product.variantLabel || '');
    mtSetValue('mt-leasing-form-currency', product.currency || 'EUR');
  }

  function mtUpdateResult(provider) {
    if (!mtCurrentProduct) return;
    mtCurrentProvider = provider;

    mtProvidersContainer.querySelectorAll('.mt-leasing-provider').forEach(function (button) {
      var mtIndex = Number.parseInt(button.getAttribute('data-mt-provider-index'), 10);
      button.setAttribute('aria-pressed', mtProviders[mtIndex] === provider ? 'true' : 'false');
    });
    var mtOtherButton = mtProvidersContainer.querySelector('[data-mt-provider-other]');
    if (mtOtherButton) mtOtherButton.setAttribute('aria-pressed', provider.other ? 'true' : 'false');

    var mtResult = provider.other ? null : mtCalculate(mtCurrentProduct.price, provider.percent);
    var mtEstimated = mtResult ? mtMoney(mtResult.estimatedNet, mtCurrentProduct.currency, mtCurrentProduct.locale) : 'Auf Anfrage';
    var mtGross = mtResult ? mtMoney(mtResult.grossMonthly, mtCurrentProduct.currency, mtCurrentProduct.locale) : 'Wird persönlich berechnet';
    var mtPrice = mtMoney(mtCurrentProduct.price, mtCurrentProduct.currency, mtCurrentProduct.locale);
    var mtFee = mtResult ? provider.percent + ' % (' + mtMoney(mtResult.fee, mtCurrentProduct.currency, mtCurrentProduct.locale) + ')' : 'Individuell';

    mtSetText('mt-leasing-estimated', mtEstimated);
    mtSetText('mt-leasing-rate-label', provider.other ? 'Monatsrate' : 'Geschätzte Nettobelastung');
    mtSetText('mt-leasing-rate-notice', provider.other ? 'Wir prüfen die Leasingkonditionen persönlich und melden uns mit einem konkreten Angebot.' : 'Unverbindliche Schätzung. Die tatsächliche Nettobelastung hängt unter anderem von Gehalt, Steuerklasse, Bundesland, Arbeitgeberkonditionen und Versicherung ab.');
    var mtRateUnit = document.getElementById('mt-leasing-rate-unit');
    if (mtRateUnit) mtRateUnit.hidden = Boolean(provider.other);
    var mtDurationRow = document.getElementById('mt-leasing-duration-row');
    if (mtDurationRow) mtDurationRow.hidden = Boolean(provider.other);
    mtSetText('mt-leasing-purchase', mtPrice);
    mtSetText('mt-leasing-provider-fee', mtFee);
    mtSetText('mt-leasing-gross', mtGross);

    var mtOfficial = document.getElementById('mt-leasing-official-link');
    if (mtOfficial) {
      mtOfficial.hidden = Boolean(provider.other);
      if (!provider.other) {
        mtOfficial.href = provider.url;
        mtOfficial.setAttribute('aria-label', 'Offiziellen Rechner von ' + provider.name + ' öffnen');
      }
    }

    mtSetValue('mt-leasing-form-subject', 'Leasing-Anfrage: ' + mtCurrentProduct.title + ' – ' + provider.name);
    mtSetValue('mt-leasing-form-product', mtCurrentProduct.title);
    mtSetValue('mt-leasing-form-sku', mtCurrentProduct.sku);
    mtSetValue('mt-leasing-form-link', mtCurrentProduct.url);
    mtSetValue('mt-leasing-form-provider', provider.name);
    mtSetValue('mt-leasing-form-percent', mtResult ? provider.percent + ' %' : '');
    mtSetValue('mt-leasing-form-price', mtPrice);
    mtSetValue('mt-leasing-form-gross', mtResult ? mtGross + ' / Monat' : '');
    mtSetValue('mt-leasing-form-estimated', mtResult ? mtEstimated + ' / Monat' : '');
    mtSetText('mt-leasing-request-provider-output', provider.name);
    mtSetText('mt-leasing-request-rate-output', mtResult ? mtEstimated + ' / Monat' : 'Persönlich berechnet');
    mtSyncProviderFields();
  }

  function mtOpen(trigger) {
    mtLastFocus = trigger;
    mtUpdateProductOutputs(mtReadProduct(trigger));
    mtCurrentProvider = mtProviders[0];
    mtRenderProviders();
    mtUpdateResult(mtCurrentProvider);

    if (mtWizard && mtWizardTeaser) {
      mtWizard.hidden = true;
      mtWizardTeaser.hidden = false;
      mtModal.classList.remove('mt-leasing-modal--wizard-active');
      mtWizardIndex = 0;
    }

    mtModal.hidden = false;
    mtModal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('mt-leasing-lock');
    document.body.classList.add('mt-leasing-lock');

    window.requestAnimationFrame(function () {
      mtPanel.focus();
    });
  }

  function mtClose() {
    mtModal.setAttribute('aria-hidden', 'true');
    mtModal.hidden = true;
    mtModal.classList.remove('mt-leasing-modal--wizard-active');
    document.documentElement.classList.remove('mt-leasing-lock');
    document.body.classList.remove('mt-leasing-lock');

    if (mtLastFocus && document.contains(mtLastFocus)) {
      mtLastFocus.focus();
    }
  }

  function mtVisibleFocusables() {
    return Array.from(mtPanel.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (element) {
      return element.offsetParent !== null;
    });
  }

  function mtSyncMobileBuybar() {
    var mtBuybar = document.getElementById('mt-mobile-buybar');
    if (!mtBuybar) return;

    var mtOriginalButton = document.querySelector('.product-form__submit, product-form button[type="submit"]');
    var mtBuybarButton = mtBuybar.querySelector('[data-mt-mobile-add]');
    var mtVisiblePrice = document.querySelector(
      '.product__info-container .price-item--sale, .product__info-container .price-item--regular'
    );
    var mtBuybarPrice = mtBuybar.querySelector('[data-mt-mobile-price]');

    if (mtBuybarPrice && mtVisiblePrice) {
      mtBuybarPrice.textContent = mtVisiblePrice.textContent.trim();
    }

    if (mtBuybarButton && mtOriginalButton) {
      /* Made with ♥ by Mister Topdesign | do not mistake a failed size request for sold-out stock */
      var mtProductInfo = mtOriginalButton.closest('product-info');
      var mtVariantPending = mtProductInfo?.classList.contains('mt-variant-pending');
      var mtVariantFailed = mtProductInfo?.classList.contains('mt-variant-failed');
      if (mtVariantPending || mtVariantFailed) {
        mtBuybarButton.disabled = true;
        mtBuybarButton.textContent = mtVariantPending ? 'Variante wird geladen …' : 'Größe erneut wählen';
        return;
      }
      var mtIsSoldOut = Boolean(mtOriginalButton.disabled);
      mtBuybarButton.disabled = false;
      mtBuybarButton.textContent = mtIsSoldOut ? 'Verfügbarkeit anfragen' : 'In den Warenkorb';
      mtBuybarButton.setAttribute('data-mt-stock-request', mtIsSoldOut ? 'true' : 'false');
    }
  }

  /* Made with ♥ by Mister Topdesign | klare Kaufaktionen und Produktverfügbarkeit */

  /* Made with ♥ by Mister Topdesign | Variantenbestand zuverlässig aus Produktdaten lesen */
  function mtSelectedVariantAvailability() {
    var mtDataNodes = Array.from(document.querySelectorAll(
      '.product__info-container variant-selects script[type="application/json"], '
      + '.product__info-container variant-radios script[type="application/json"]'
    ));

    var mtVariantIdInput = document.querySelector(
      '.product__info-container product-form input[name="id"], '
      + '.product__info-container form[action*="/cart/add"] input[name="id"]'
    );
    var mtVariantId = mtVariantIdInput ? String(mtVariantIdInput.value || '') : '';

    for (var mtIndex = mtDataNodes.length - 1; mtIndex >= 0; mtIndex -= 1) {
      try {
        var mtVariantData = JSON.parse(mtDataNodes[mtIndex].textContent || 'null');

        if (mtVariantData && !Array.isArray(mtVariantData)
          && typeof mtVariantData.available === 'boolean' && (!mtVariantId || String(mtVariantData.id) === mtVariantId)) {
          return mtVariantData.available;
        }

        if (Array.isArray(mtVariantData)) {
          var mtSelectedVariant = mtVariantId
            ? mtVariantData.find(function (mtVariant) {
                return String(mtVariant.id) === mtVariantId;
              })
            : null;

          if (mtSelectedVariant && typeof mtSelectedVariant.available === 'boolean') {
            return mtSelectedVariant.available;
          }
        }
      } catch (mtError) {
        continue;
      }
    }

    return null;
  }

  function mtSyncProductStockState() {
    if (!document.body.classList.contains('mt-product-page--enhanced')) return;

    var mtButtons = document.querySelector('.product__info-container .product-form__buttons');
    var mtSubmit = document.querySelector('.product__info-container .product-form__submit');
    if (!mtButtons || !mtSubmit) return;

    var mtVariantAvailable = mtSelectedVariantAvailability();
    var mtSoldOut = mtVariantAvailable === false
      || (mtVariantAvailable === null && Boolean(mtSubmit.disabled));
    document.body.classList.toggle('mt-product-page--sold-out', mtSoldOut);

    var mtRequest = mtButtons.querySelector('.mt-product-stock-request');
    var mtStockNote = mtButtons.querySelector('.mt-product-stock-note');

    if (!mtSoldOut) {
      if (mtRequest) mtRequest.remove();
      if (mtStockNote) mtStockNote.remove();
      return;
    }

    if (!mtStockNote) {
      mtStockNote = document.createElement('p');
      mtStockNote.className = 'mt-product-stock-note';
      mtStockNote.textContent = 'Diese Variante ist aktuell nicht direkt verfügbar. Wir prüfen Bestand und Liefertermin persönlich.';
      mtButtons.appendChild(mtStockNote);
    }

    if (!mtRequest) {
      mtRequest = document.createElement('a');
      mtRequest.className = 'mt-product-stock-request';
      var mtHeading = document.querySelector('.product__title h1');
      var mtTitle = (mtHeading ? mtHeading.textContent : document.title).trim();
      mtRequest.href = '/pages/terminanfrage?produkt=' + encodeURIComponent(mtTitle);
      mtRequest.textContent = 'Verfügbarkeit anfragen';
      mtRequest.setAttribute('aria-label', 'Verfügbarkeit für ' + mtTitle + ' anfragen');
      mtButtons.appendChild(mtRequest);
    }
  }

  function mtPurchaseTrustIcon(mtType) {
    var mtSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    mtSvg.classList.add('mt-purchase-trust__svg');
    mtSvg.setAttribute('viewBox', '0 0 24 24');
    mtSvg.setAttribute('aria-hidden', 'true');
    mtSvg.setAttribute('fill', 'none');
    mtSvg.setAttribute('stroke', 'currentColor');
    mtSvg.setAttribute('stroke-width', '1.7');
    mtSvg.setAttribute('stroke-linecap', 'round');
    mtSvg.setAttribute('stroke-linejoin', 'round');

    var mtPaths = {
      advice: ['M4 5h16v11H8l-4 3Z', 'M8 9h8', 'M8 12h5'],
      assembly: ['M14.7 6.3a4 4 0 0 0-5-5L12 3.6 9.6 6 7.3 3.7a4 4 0 0 0 5 5L17 19.4a2 2 0 1 0 2.8-2.8Z'],
      shipping: ['M3 6h11v10H3Z', 'M14 10h4l3 3v3h-7Z', 'M7 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z', 'M18 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z']
    };

    (mtPaths[mtType] || mtPaths.advice).forEach(function (mtPathData) {
      var mtPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      mtPath.setAttribute('d', mtPathData);
      mtSvg.appendChild(mtPath);
    });

    return mtSvg;
  }

  function mtInitializePurchaseArea() {
    var mtButtons = document.querySelector('.product__info-container .product-form__buttons');
    var mtSubmit = document.querySelector('.product__info-container .product-form__submit');

    if (mtButtons) mtButtons.classList.add('mt-purchase-actions');

    if (mtSubmit) {
      mtSubmit.classList.add('mt-purchase-primary');
      var mtSubmitText = mtSubmit.querySelector('span');
      if (!mtSubmit.disabled && mtSubmitText) mtSubmitText.textContent = 'In den Warenkorb';
    }

    var mtDirectContainer = document.querySelector('.product__info-container .shopify-payment-button');
    if (mtDirectContainer) mtDirectContainer.classList.add('mt-purchase-direct');

    var mtDirectButton = document.querySelector(
      '.product__info-container .shopify-payment-button__button--unbranded'
    );
    if (mtDirectButton) {
      mtDirectButton.textContent = 'Direkt zur Kasse';
      mtDirectButton.setAttribute('aria-label', 'Dieses Bike direkt zur Kasse bringen');
    }

    var mtPayments = document.querySelector('.product__info-container > .mt-payments-centered');
    if (mtPayments) {
      mtPayments.classList.add('mt-purchase-payments');
      if (!mtPayments.querySelector('.mt-purchase-payments__label')) {
        var mtPaymentLabel = document.createElement('span');
        mtPaymentLabel.className = 'mt-purchase-payments__label';
        mtPaymentLabel.textContent = 'Sicher bezahlen mit';
        mtPayments.insertBefore(mtPaymentLabel, mtPayments.firstChild);
      }
    }

    var mtTrust = document.querySelector(
      '.product__info-container > .icon-with-text--horizontal'
    );
    if (!mtTrust) return;

    mtTrust.classList.add('mt-purchase-trust');
    var mtTrustItems = Array.from(mtTrust.querySelectorAll('.icon-with-text__item'));
    var mtTrustData = [
      { label: 'Persönliche Beratung', icon: 'advice' },
      { label: 'Fachgerecht vormontiert', icon: 'assembly' },
      { label: 'Sicherer Bike-Versand', icon: 'shipping' }
    ];

    mtTrustItems.forEach(function (mtItem, mtIndex) {
      var mtData = mtTrustData[mtIndex];
      if (!mtData) return;

      mtItem.classList.add('mt-purchase-trust__item');

      var mtIconWrap = mtItem.querySelector('.svg-wrapper');
      if (mtIconWrap && mtIconWrap.getAttribute('data-mt-purchase-icon') !== mtData.icon) {
        mtIconWrap.classList.add('mt-purchase-trust__icon');
        mtIconWrap.replaceChildren(mtPurchaseTrustIcon(mtData.icon));
        mtIconWrap.setAttribute('data-mt-purchase-icon', mtData.icon);
      }

      var mtText = mtItem.querySelector('.inline-richtext');
      if (mtText) {
        mtText.classList.add('mt-purchase-trust__text');
        mtText.textContent = mtData.label;
      }
    });
  }

  /* Made with ♥ by Mister Topdesign | universal product description */
  function mtInitializeUniversalProductDescription() {
    var mtDescriptionHost = document.getElementById('mt-product-description-host');
    if (!mtDescriptionHost) return;

    var mtAftercare = document.getElementById('mt-product-aftercare');
    var mtService = mtAftercare ? mtAftercare.querySelector('.mt-product-service') : null;
    var mtRelated = document.querySelector('[id*="__related-products"]');
    var mtQuestionSection = document.querySelector('[id*="__custom_liquid_DWYcH8"]');

    if (mtService) {
      if (mtDescriptionHost.parentNode !== mtService) mtService.appendChild(mtDescriptionHost);
    } else if (mtRelated) {
      if (mtDescriptionHost.nextElementSibling !== mtRelated) {
        mtRelated.parentNode.insertBefore(mtDescriptionHost, mtRelated);
      }
    } else if (mtQuestionSection && mtQuestionSection.parentNode) {
      mtQuestionSection.parentNode.insertBefore(mtDescriptionHost, mtQuestionSection.nextSibling);
    }

    mtDescriptionHost.hidden = false;
    mtDescriptionHost.setAttribute('data-mt-product-description-ready', 'true');
  }

  /* Made with ♥ by Mister Topdesign | responsive product details and question form */
  function mtSyncResponsiveProductSections() {
    var mtShouldOpen = mtProductDesktopQuery.matches;
    var mtProductDetails = document.querySelector('.mt-product-details');
    var mtQuestionDetails = document.getElementById('rh-product-questions');
    var mtQuestionForm = document.getElementById('ProductQuestionFormDawn');
    var mtQuestionHasStatus = window.location.hash === '#ProductQuestionFormDawn' || Boolean(
      mtQuestionForm && mtQuestionForm.querySelector('.form-status, .form__message, [role="alert"]')
    );

    if (mtProductDetails) mtProductDetails.open = mtShouldOpen;
    if (mtQuestionDetails && !mtQuestionDetails.hasAttribute('data-mt-question-initialized')) {
      mtQuestionDetails.open = mtQuestionHasStatus;
      mtQuestionDetails.setAttribute('data-mt-question-initialized', 'true');
    }
  }

  function mtSyncProductQuestionForm() {
    var mtQuestionForm = document.getElementById('ProductQuestionFormDawn');
    if (!mtQuestionForm) return;

    var mtProductInput = mtQuestionForm.querySelector('input[name="contact[Produkt]"]');
    var mtSkuInput = mtQuestionForm.querySelector('input[name="contact[SKU]"]');
    var mtLinkInput = mtQuestionForm.querySelector('input[name="contact[Produkt-Link]"]');
    var mtSubjectInput = mtQuestionForm.querySelector('input[name="contact[subject]"]');
    var mtTitleElement = document.querySelector('.product__title h1');
    var mtSkuElement = document.querySelector('.product__info-container .caption-with-letter-spacing');
    var mtProductTitle = (mtTitleElement ? mtTitleElement.textContent : document.title).trim();
    var mtSku = (mtSkuElement ? mtSkuElement.textContent : '').replace(/^SKU:\s*/i, '').trim();

    var mtVariantOptions = Array.from(document.querySelectorAll(
      'variant-selects input[type="radio"]:checked, variant-radios input[type="radio"]:checked, variant-selects select, variant-radios select'
    ));
    var mtVariantText = mtVariantOptions.map(function (mtOption) {
      if (mtOption.tagName === 'SELECT') {
        var mtSelectedOption = mtOption.options[mtOption.selectedIndex];
        return mtSelectedOption ? mtSelectedOption.textContent.trim() : '';
      }
      return String(mtOption.value || '').trim();
    }).filter(Boolean).join(' / ');

    var mtVariantInput = mtQuestionForm.querySelector('input[name="contact[Variante]"]');
    if (!mtVariantInput) {
      mtVariantInput = document.createElement('input');
      mtVariantInput.type = 'hidden';
      mtVariantInput.name = 'contact[Variante]';
      mtQuestionForm.appendChild(mtVariantInput);
    }

    if (mtProductInput) mtProductInput.value = mtProductTitle;
    if (mtSkuInput) mtSkuInput.value = mtSku;
    if (mtLinkInput) mtLinkInput.value = window.location.href.split('?')[0];
    mtVariantInput.value = mtVariantText || 'Standard';

    if (mtSubjectInput) {
      mtSubjectInput.value = 'Produktfrage: ' + mtProductTitle
        + (mtSku ? ' – SKU: ' + mtSku : '')
        + (mtVariantText ? ' – Variante: ' + mtVariantText : '');
    }
  }

  if (typeof mtProductDesktopQuery.addEventListener === 'function') {
    mtProductDesktopQuery.addEventListener('change', mtSyncResponsiveProductSections);
  } else {
    mtProductDesktopQuery.addListener(mtSyncResponsiveProductSections);
  }


  /* Made with ♥ by Mister Topdesign | Liefertermin und kostenfreien Versand gemeinsam darstellen */
  function mtDeliveryIcon(mtType) {
    var mtIcon = document.createElement('span');
    mtIcon.className = 'mt-delivery-service__icon';
    mtIcon.setAttribute('aria-hidden', 'true');

    var mtSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    mtSvg.setAttribute('viewBox', '0 0 24 24');
    mtSvg.setAttribute('fill', 'none');
    mtSvg.setAttribute('stroke', 'currentColor');
    mtSvg.setAttribute('stroke-width', '1.7');
    mtSvg.setAttribute('stroke-linecap', 'round');
    mtSvg.setAttribute('stroke-linejoin', 'round');

    var mtPaths = mtType === 'calendar'
      ? ['M6 3v3', 'M18 3v3', 'M4 8h16', 'M5 5h14a1 1 0 0 1 1 1v14H4V6a1 1 0 0 1 1-1Z', 'm8 12 2 2 4-4']
      : ['M3 6h11v10H3Z', 'M14 10h4l3 3v3h-7Z', 'M7 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z', 'M18 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z'];

    mtPaths.forEach(function (mtPathData) {
      var mtPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      mtPath.setAttribute('d', mtPathData);
      mtSvg.appendChild(mtPath);
    });

    mtIcon.appendChild(mtSvg);
    return mtIcon;
  }

  /* Made with ♥ by Mister Topdesign | bedingte Versandkommunikation */

  function mtTaxSeparator() {
    var mtSeparator = document.createElement('span');
    mtSeparator.className = 'mt-product-tax__separator';
    mtSeparator.setAttribute('aria-hidden', 'true');
    mtSeparator.textContent = '·';
    return mtSeparator;
  }

  function mtSyncConditionalShippingText() {
    var mtTax = document.querySelector('.product__info-container > .product__tax');
    if (!mtTax) return;

    if (!mtTaxOriginalContent.has(mtTax)) {
      var mtOriginalLink = mtTax.querySelector('a[href*="shipping"], a[href*="versand"]');
      mtTaxOriginalContent.set(mtTax, {
        nodes: Array.from(mtTax.childNodes).map(function (mtNode) {
          return mtNode.cloneNode(true);
        }),
        href: mtOriginalLink ? mtOriginalLink.getAttribute('href') : '/policies/shipping-policy'
      });
    }

    var mtOriginal = mtTaxOriginalContent.get(mtTax);
    var mtHasFreeShipping = Boolean(document.querySelector('.rh-shipfree-pill:not([hidden])'));

    if (!mtHasFreeShipping) {
      if (mtTax.getAttribute('data-mt-shipping-state') === 'free') {
        mtTax.replaceChildren.apply(mtTax, mtOriginal.nodes.map(function (mtNode) {
          return mtNode.cloneNode(true);
        }));
      }
      mtTax.classList.remove('mt-product-tax--free');
      mtTax.removeAttribute('data-mt-shipping-state');
      return;
    }

    if (mtTax.getAttribute('data-mt-shipping-state') === 'free') return;

    var mtTaxBase = document.createElement('span');
    mtTaxBase.className = 'mt-product-tax__base';
    mtTaxBase.textContent = 'inkl. MwSt.';

    var mtTaxFree = document.createElement('span');
    mtTaxFree.className = 'mt-product-tax__free';
    mtTaxFree.textContent = 'Kostenfreie Lieferung';

    var mtTaxLink = document.createElement('a');
    mtTaxLink.className = 'mt-product-tax__link';
    mtTaxLink.href = mtOriginal.href || '/policies/shipping-policy';
    mtTaxLink.textContent = 'Versandinformationen';

    var mtTaxLinkGroup = document.createElement('span');
    mtTaxLinkGroup.className = 'mt-product-tax__link-group';
    mtTaxLinkGroup.append(mtTaxSeparator(), mtTaxLink);

    mtTax.replaceChildren(
      mtTaxBase,
      mtTaxSeparator(),
      mtTaxFree,
      mtTaxLinkGroup
    );
    mtTax.classList.add('mt-product-tax--free');
    mtTax.setAttribute('data-mt-shipping-state', 'free');
  }

  /* Made with ♥ by Mister Topdesign | Lieferkarten auch bei einzelnen Liquid-Blöcken stabil aufbauen */
  function mtInitializeDeliveryService() {
    var mtEtaItems = Array.from(document.querySelectorAll('.rh-eta-pill'));
    var mtShipItem = document.querySelector('.rh-shipfree-pill:not([hidden])');
    var mtReferenceItem = mtEtaItems[0] || mtShipItem;
    var mtWrapper = document.querySelector('.mt-delivery-service');

    /* Made with ♥ by Mister Topdesign | no delivery promise for unavailable variants */
    var mtSelectedAvailable = mtSelectedVariantAvailability();
    var mtSelectedSubmit = document.querySelector('.product__info-container .product-form__submit');
    var mtProductState = mtSelectedSubmit?.closest('product-info');
    var mtUnavailable = mtSelectedAvailable === false
      || Boolean(mtProductState?.classList.contains('mt-variant-pending') || mtProductState?.classList.contains('mt-variant-failed'))
      || (mtSelectedAvailable === null && Boolean(mtSelectedSubmit?.disabled));
    mtEtaItems.forEach(function (mtEtaItem) {
      if (mtUnavailable) mtEtaItem.style.setProperty('display', 'none', 'important');
      else mtEtaItem.style.removeProperty('display');
    });
    if (mtWrapper) mtWrapper.classList.toggle('mt-delivery-service--shipping-only', mtUnavailable);

    if (!mtReferenceItem) {
      if (mtWrapper && !mtWrapper.children.length) mtWrapper.remove();
      mtSyncConditionalShippingText();
      return;
    }

    if (!mtWrapper) {
      mtWrapper = document.createElement('div');
      mtWrapper.className = 'mt-delivery-service';
      mtReferenceItem.parentNode.insertBefore(mtWrapper, mtReferenceItem);
    }

    var mtHasEta = mtEtaItems.length > 0 && !mtUnavailable;
    var mtHasShipping = Boolean(mtShipItem);
    mtWrapper.style.display = mtHasEta || mtHasShipping ? '' : 'none';
    mtWrapper.classList.toggle('mt-delivery-service--eta-only', mtHasEta && !mtHasShipping);
    mtWrapper.classList.toggle('mt-delivery-service--shipping-only', !mtHasEta && mtHasShipping);

    var mtAriaLabel = mtHasEta && mtHasShipping
      ? 'Liefer- und Versandinformationen'
      : (mtHasEta ? 'Lieferinformationen' : 'Versandinformationen');
    mtWrapper.setAttribute('aria-label', mtAriaLabel);

    mtEtaItems.forEach(function (mtEtaItem) {
      if (!mtEtaItem.classList.contains('mt-delivery-service__item')) {
        mtEtaItem.classList.add('mt-delivery-service__item', 'mt-delivery-service__item--eta');
        mtEtaItem.insertBefore(mtDeliveryIcon('calendar'), mtEtaItem.firstChild);

        var mtEtaText = mtEtaItem.querySelector('.rh-eta-pill__text');
        if (mtEtaText && !mtEtaText.querySelector('.mt-delivery-service__label')) {
          var mtEtaLabel = document.createElement('span');
          mtEtaLabel.className = 'mt-delivery-service__label';
          mtEtaLabel.textContent = 'Lieferung';
          mtEtaText.insertBefore(mtEtaLabel, mtEtaText.firstChild);
        }
      }

      if (mtEtaItem.parentNode !== mtWrapper) mtWrapper.appendChild(mtEtaItem);
    });

    if (mtShipItem) {
      if (!mtShipItem.classList.contains('mt-delivery-service__item')) {
        mtShipItem.classList.add('mt-delivery-service__item', 'mt-delivery-service__item--shipping');
        mtShipItem.insertBefore(mtDeliveryIcon('truck'), mtShipItem.firstChild);

        var mtShipText = mtShipItem.querySelector('.rh-shipfree-pill__text');
        if (mtShipText) {
          if (!mtShipText.querySelector('.mt-delivery-service__label')) {
            var mtShipLabel = document.createElement('span');
            mtShipLabel.className = 'mt-delivery-service__label';
            mtShipLabel.textContent = 'Versand';
            mtShipText.insertBefore(mtShipLabel, mtShipText.firstChild);
          }

          if (!mtShipText.querySelector('.mt-delivery-service__detail')) {
            var mtShipDetail = document.createElement('span');
            mtShipDetail.className = 'mt-delivery-service__detail';
            mtShipDetail.textContent = 'Für dieses Bike ohne Versandkosten';
            mtShipText.appendChild(mtShipDetail);
          }
        }
      }

      if (mtShipItem.parentNode !== mtWrapper) mtWrapper.appendChild(mtShipItem);
    }

    mtSyncConditionalShippingText();
  }

  /* Made with ♥ by Mister Topdesign | kleine Produktgalerien automatisch zentrieren */
  function mtSyncThumbnailAlignment() {
    document.querySelectorAll('.thumbnail-list').forEach(function (mtThumbnailList) {
      var mtHasOverflow = mtThumbnailList.scrollWidth > mtThumbnailList.clientWidth + 2;
      mtThumbnailList.classList.toggle('mt-thumbnail-list--centered', !mtHasOverflow);
    });
  }

  window.addEventListener('resize', function () {
    window.requestAnimationFrame(mtSyncThumbnailAlignment);
  }, { passive: true });

  /* Made with ♥ by Mister Topdesign */
  document.addEventListener('mt-variant-request-state', function () { mtSyncMobileBuybar(); mtInitializeDeliveryService(); });

  /* Made with ♥ by Mister Topdesign | automatisch zuletzt angesehene Produkte */
  var mtRecentStorageKey = 'mt-recent-products-v1';

  function mtRecentText(mtTag, mtClassName, mtText) {
    var mtElement = document.createElement(mtTag);
    mtElement.className = mtClassName;
    mtElement.textContent = mtText || '';
    return mtElement;
  }

  function mtSafeRecentUrl(mtItem) {
    var mtUrl = typeof mtItem.url === 'string' ? mtItem.url : '';
    if (mtUrl.charAt(0) === '/' && mtUrl.slice(0, 2) !== '//') return mtUrl;
    return '/products/' + encodeURIComponent(mtItem.handle || '');
  }

  function mtSafeRecentImage(mtImage) {
    if (typeof mtImage !== 'string') return '';
    if (/^https?:\/\//i.test(mtImage) || mtImage.slice(0, 2) === '//') return mtImage;
    return '';
  }

  function mtBuildRecentProduct(mtItem) {
    var mtCard = document.createElement('article');
    mtCard.className = 'mt-recent-products__card';
    mtCard.setAttribute('role', 'listitem');

    var mtLink = document.createElement('a');
    mtLink.className = 'mt-recent-products__link';
    mtLink.href = mtSafeRecentUrl(mtItem);
    mtLink.setAttribute('aria-label', (mtItem.title || 'Produkt') + ' ansehen');

    var mtMedia = document.createElement('span');
    mtMedia.className = 'mt-recent-products__media';

    var mtImageUrl = mtSafeRecentImage(mtItem.image);
    if (mtImageUrl) {
      var mtImage = document.createElement('img');
      mtImage.className = 'mt-recent-products__image';
      mtImage.src = mtImageUrl;
      mtImage.alt = mtItem.title || '';
      mtImage.loading = 'lazy';
      mtImage.width = 900;
      mtImage.height = 675;
      mtMedia.appendChild(mtImage);
    }

    var mtBody = document.createElement('span');
    mtBody.className = 'mt-recent-products__body';

    if (mtItem.vendor) {
      mtBody.appendChild(mtRecentText('span', 'mt-recent-products__vendor', mtItem.vendor));
    }

    mtBody.appendChild(mtRecentText('span', 'mt-recent-products__name', mtItem.title || 'Produkt'));

    var mtFooter = document.createElement('span');
    mtFooter.className = 'mt-recent-products__footer';

    var mtPrices = document.createElement('span');
    mtPrices.className = 'mt-recent-products__prices';

    if (mtItem.compare && mtItem.compare !== mtItem.price) {
      var mtCompare = mtRecentText('s', 'mt-recent-products__compare', mtItem.compare);
      mtPrices.appendChild(mtCompare);
    }

    mtPrices.appendChild(mtRecentText('strong', 'mt-recent-products__price', mtItem.price || ''));
    mtFooter.appendChild(mtPrices);
    mtFooter.appendChild(mtRecentText('span', 'mt-recent-products__arrow', '→'));
    mtBody.appendChild(mtFooter);

    mtLink.appendChild(mtMedia);
    mtLink.appendChild(mtBody);
    mtCard.appendChild(mtLink);
    return mtCard;
  }

  function mtInitializeRecentProducts(mtRelated) {
    var mtSection = document.getElementById('mt-recent-products');
    if (!mtSection) return;

    if (mtRelated && mtRelated.parentNode && mtRelated.nextElementSibling !== mtSection) {
      mtRelated.parentNode.insertBefore(mtSection, mtRelated.nextSibling);
    }

    var mtTrack = mtSection.querySelector('[data-mt-recent-products]');
    if (!mtTrack) return;

    var mtCurrent = {
      handle: mtSection.getAttribute('data-mt-recent-handle') || '',
      title: mtSection.getAttribute('data-mt-recent-title') || '',
      url: mtSection.getAttribute('data-mt-recent-url') || '',
      image: mtSection.getAttribute('data-mt-recent-image') || '',
      vendor: mtSection.getAttribute('data-mt-recent-vendor') || '',
      price: mtSection.getAttribute('data-mt-recent-price') || '',
      compare: mtSection.getAttribute('data-mt-recent-compare') || ''
    };

    var mtStored = [];
    try {
      var mtParsed = JSON.parse(window.localStorage.getItem(mtRecentStorageKey) || '[]');
      if (Array.isArray(mtParsed)) mtStored = mtParsed;
    } catch (mtError) {
      mtStored = [];
    }

    var mtVisible = mtStored.filter(function (mtItem) {
      return mtItem && mtItem.handle && mtItem.handle !== mtCurrent.handle && mtItem.title;
    }).slice(0, 4);

    mtTrack.replaceChildren();
    mtVisible.forEach(function (mtItem) {
      mtTrack.appendChild(mtBuildRecentProduct(mtItem));
    });
    mtSection.hidden = mtVisible.length === 0;

    if (!mtCurrent.handle || !mtCurrent.title) return;

    var mtUpdated = [mtCurrent].concat(mtStored.filter(function (mtItem) {
      return mtItem && mtItem.handle !== mtCurrent.handle;
    })).slice(0, 8);

    try {
      window.localStorage.setItem(mtRecentStorageKey, JSON.stringify(mtUpdated));
    } catch (mtError) {
      /* Die Produktseite bleibt auch ohne verfügbaren Browser-Speicher vollständig nutzbar. */
    }
  }

  /* Made with ♥ by Mister Topdesign | passendes Zubehör als ruhiges Kaufmodul */
  function mtComplementaryIcon() {
    var mtSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    mtSvg.classList.add('mt-complementary__icon-svg');
    mtSvg.setAttribute('viewBox', '0 0 24 24');
    mtSvg.setAttribute('aria-hidden', 'true');
    mtSvg.setAttribute('fill', 'none');
    mtSvg.setAttribute('stroke', 'currentColor');
    mtSvg.setAttribute('stroke-width', '1.7');
    mtSvg.setAttribute('stroke-linecap', 'round');

    var mtCircle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    mtCircle.setAttribute('cx', '12');
    mtCircle.setAttribute('cy', '12');
    mtCircle.setAttribute('r', '9');

    var mtVertical = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    mtVertical.setAttribute('d', 'M12 8v8');

    var mtHorizontal = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    mtHorizontal.setAttribute('d', 'M8 12h8');

    mtSvg.append(mtCircle, mtVertical, mtHorizontal);
    return mtSvg;
  }

  function mtSetComplementaryButtonLabel(mtButton, mtLabel) {
    var mtLabelSpan = Array.from(mtButton.children).find(function (mtChild) {
      return mtChild.tagName === 'SPAN'
        && !mtChild.classList.contains('sold-out-message')
        && !mtChild.classList.contains('icon-wrap');
    });

    var mtTextNodes = Array.from(mtButton.childNodes).filter(function (mtNode) {
      return mtNode.nodeType === Node.TEXT_NODE && mtNode.textContent.trim();
    });

    if (mtLabelSpan) {
      if (mtLabelSpan.textContent.trim() !== mtLabel) mtLabelSpan.textContent = mtLabel;
      mtTextNodes.forEach(function (mtTextNode) {
        mtTextNode.remove();
      });
      return;
    }

    var mtTextNode = mtTextNodes[0];
    if (mtTextNode) {
      if (mtTextNode.textContent.trim() !== mtLabel) mtTextNode.textContent = mtLabel + ' ';
    } else {
      mtButton.insertBefore(document.createTextNode(mtLabel + ' '), mtButton.firstChild);
    }
  }

  function mtInitializeComplementaryProducts() {
    /* Made with ♥ by Mister Topdesign | full-width complementary products */
    document.querySelectorAll('product-recommendations.complementary-products').forEach(function (mtBlock) {
      mtBlock.classList.add('mt-complementary');

      var mtProducts = mtBlock.querySelectorAll('.complementary-slide li product-component');
      if (!mtProducts.length) return;

      mtBlock.setAttribute('aria-label', 'Das passt dazu');

      var mtDetails = mtBlock.querySelector('details');
      if (mtDetails) mtDetails.open = true;

      var mtHost = mtBlock.closest('.mt-complementary-section');
      if (!mtHost) {
        var mtProductRoot = mtBlock.closest('.product');
        if (!mtProductRoot) return;

        mtHost = document.createElement('section');
        mtHost.className = 'mt-complementary-section';
        mtHost.setAttribute('aria-label', 'Passendes Zubehör');
        mtProductRoot.insertAdjacentElement('afterend', mtHost);
        mtHost.appendChild(mtBlock);
      }

      var mtHeader = mtHost.querySelector(':scope > .mt-complementary__header');
      if (!mtHeader) {
        mtHeader = document.createElement('div');
        mtHeader.className = 'mt-complementary__header';

        var mtHeaderCopy = document.createElement('div');
        mtHeaderCopy.className = 'mt-complementary__header-copy';

        var mtEyebrow = document.createElement('p');
        mtEyebrow.className = 'mt-complementary__eyebrow';
        mtEyebrow.textContent = 'Ausgewähltes Zubehör';

        var mtTitle = document.createElement('h2');
        mtTitle.className = 'mt-complementary__title';
        mtTitle.textContent = 'Das passt dazu';

        var mtIntro = document.createElement('p');
        mtIntro.className = 'mt-complementary__intro';
        mtIntro.textContent = 'Sinnvolle Ergänzungen, passend zu diesem Produkt ausgewählt.';

        mtHeaderCopy.append(mtEyebrow, mtTitle);
        mtHeader.append(mtHeaderCopy, mtIntro);
        mtHost.insertBefore(mtHeader, mtBlock);
      }

      var mtSummaryHeading = mtBlock.querySelector('.accordion__title');
      if (mtSummaryHeading && mtSummaryHeading.textContent.trim() !== 'Das passt dazu') {
        mtSummaryHeading.textContent = 'Das passt dazu';
      }

      mtBlock.querySelectorAll('.complementary-slide li').forEach(function (mtItem) {
        mtItem.classList.add('mt-complementary__item');
      });

      mtBlock.querySelectorAll('product-component').forEach(function (mtProduct) {
        mtProduct.classList.add('mt-complementary__product');

        var mtCard = mtProduct.querySelector('.card-wrapper');
        if (mtCard) mtCard.classList.add('mt-complementary__card');

        var mtButton = mtProduct.querySelector('.quick-add__submit');
        if (!mtButton) return;

        var mtHasOptions = Boolean(mtButton.closest('modal-opener'));
        mtButton.classList.add(
          'mt-complementary__action',
          mtHasOptions ? 'mt-complementary__action--options' : 'mt-complementary__action--add'
        );
        mtSetComplementaryButtonLabel(
          mtButton,
          mtHasOptions ? 'Ausführung wählen' : 'Hinzufügen'
        );
      });

      mtBlock.setAttribute('data-mt-complementary-ready', 'true');
    });
  }
  function mtInitializeProductEnhancements() {
    var mtAftercare = document.getElementById('mt-product-aftercare');
    var mtRelated = document.querySelector('[id*="__related-products"]');
    var mtBuybar = document.getElementById('mt-mobile-buybar');

    if (mtAftercare) {
      if (mtRelated && mtAftercare.nextElementSibling !== mtRelated) {
        mtRelated.parentNode.insertBefore(mtAftercare, mtRelated);
      }
      mtAftercare.hidden = false;
    }

    mtInitializeUniversalProductDescription();

    if (mtRelated) {
      var mtRelatedHeading = mtRelated.querySelector('h2');
      if (mtRelatedHeading) mtRelatedHeading.textContent = 'Das könnte dir auch gefallen';
    }

    mtInitializeRecentProducts(mtRelated);
    mtInitializeDeliveryService();
    mtInitializeComplementaryProducts();
    mtSyncThumbnailAlignment();
    window.requestAnimationFrame(mtSyncThumbnailAlignment);

    if (mtBuybar) mtBuybar.hidden = false;
    mtSyncMobileBuybar();
    mtInitializePurchaseArea();
    mtSyncProductStockState();
    mtSyncResponsiveProductSections();
    mtSyncProductQuestionForm();
  }

  document.addEventListener('submit', function (event) {
    if (!event.target || event.target.id !== 'mt-leasing-request-form') return;

    for (var mtStepIndex = 0; mtStepIndex < mtWizardSteps.length; mtStepIndex += 1) {
      if (!mtWizardValidateStep(mtStepIndex)) {
        event.preventDefault();
        return;
      }
    }

    var mtSizeField = document.getElementById('mt-leasing-size');
    var mtSize = mtSizeField ? mtSizeField.value.trim() : '';
    var mtProviderName = mtSelectedProviderName();
    var mtSubject = 'Leasing-Anfrage: ' + (mtCurrentProduct ? mtCurrentProduct.title : 'Bike');

    if (mtProviderName) mtSubject += ' – ' + mtProviderName;
    if (mtSize) mtSubject += ' – Größe ' + mtSize;

    mtSetValue('mt-leasing-form-subject', mtSubject);
    mtSetValue('mt-leasing-form-provider', mtProviderName);
  });

  document.addEventListener('click', function (event) {
    var mtWizardStartButton = event.target.closest('[data-mt-wizard-start]');
    if (mtWizardStartButton) {
      event.preventDefault();
      mtWizardStart(true);
      return;
    }

    var mtWizardNextButton = event.target.closest('[data-mt-wizard-next]');
    if (mtWizardNextButton) {
      event.preventDefault();
      mtWizardNext();
      return;
    }

    var mtWizardBackButton = event.target.closest('[data-mt-wizard-back]');
    if (mtWizardBackButton) {
      event.preventDefault();
      if (mtWizardIndex > 0) {
        mtWizardShowStep(mtWizardIndex - 1, true);
      } else {
        mtWizardReturnToTeaser();
      }
      return;
    }

    var mtOpenButton = event.target.closest('[data-mt-open-leasing]');
    if (mtOpenButton) {
      event.preventDefault();
      mtOpen(mtOpenButton);
      return;
    }

    var mtSecondaryOpen = event.target.closest('[data-mt-open-leasing-secondary]');
    if (mtSecondaryOpen) {
      event.preventDefault();
      var mtPrimaryTrigger = document.querySelector('[data-mt-open-leasing]');
      if (mtPrimaryTrigger) mtOpen(mtPrimaryTrigger);
      return;
    }

    var mtMobileAdd = event.target.closest('[data-mt-mobile-add]');
    if (mtMobileAdd) {
      event.preventDefault();
      if (mtMobileAdd.getAttribute('data-mt-stock-request') === 'true') {
        var mtStockRequest = document.querySelector('.mt-product-stock-request');
        if (mtStockRequest) mtStockRequest.click();
        return;
      }
      var mtOriginalAdd = document.querySelector('.product-form__submit, product-form button[type="submit"]');
      if (mtOriginalAdd && !mtOriginalAdd.disabled) mtOriginalAdd.click();
      return;
    }

    var mtProviderButton = event.target.closest('[data-mt-provider-index]');
    if (mtProviderButton && mtModal.contains(mtProviderButton)) {
      var mtProviderIndex = Number.parseInt(mtProviderButton.getAttribute('data-mt-provider-index'), 10);
      if (mtProviders[mtProviderIndex]) mtUpdateResult(mtProviders[mtProviderIndex]);
      return;
    }

    var mtOtherProviderButton = event.target.closest('[data-mt-provider-other]');
    if (mtOtherProviderButton && mtModal.contains(mtOtherProviderButton)) {
      mtUpdateResult(mtOtherProvider);
      return;
    }

    if (event.target.closest('[data-mt-leasing-close]')) {
      event.preventDefault();
      mtClose();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (mtModal.hidden) return;

    if (
      event.key === 'Enter'
      && mtWizard
      && !mtWizard.hidden
      && event.target.closest('[data-mt-wizard-step]')
      && event.target.tagName !== 'TEXTAREA'
      && !event.target.matches('button, a')
      && mtWizardIndex < mtWizardSteps.length - 1
    ) {
      event.preventDefault();
      mtWizardNext();
      return;
    }

    if (event.key === 'Escape') {
      event.preventDefault();
      mtClose();
      return;
    }

    if (event.key !== 'Tab') return;

    var mtFocusables = mtVisibleFocusables();
    if (!mtFocusables.length) {
      event.preventDefault();
      mtPanel.focus();
      return;
    }

    var mtFirst = mtFocusables[0];
    var mtLast = mtFocusables[mtFocusables.length - 1];

    if (event.shiftKey && document.activeElement === mtFirst) {
      event.preventDefault();
      mtLast.focus();
    } else if (!event.shiftKey && document.activeElement === mtLast) {
      event.preventDefault();
      mtFirst.focus();
    }
  });

  document.addEventListener('input', function (event) {
    if (event.target.closest('#mt-leasing-request-form')) {
      if (event.target.setCustomValidity) event.target.setCustomValidity('');
      if (event.target.matches('[data-mt-provider-other-select], [data-mt-provider-other-name]')) mtSyncProviderFields();
      mtWizardSyncPersonalization();
    }
  });

  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-mt-provider-other-select], [data-mt-provider-other-name]') && event.target.closest('#mt-leasing-request-form')) {
      mtSyncProviderFields();
    }
  });

  var mtObserver = new MutationObserver(function (mutations) {
    var mtNeedsRefresh = mutations.some(function (mutation) {
      return Array.from(mutation.addedNodes).some(function (node) {
        return node.nodeType === 1 && (
          node.matches?.('[data-open-leasing]') ||
          node.querySelector?.('[data-open-leasing]')
        );
      });
    });

    var mtNeedsBuybarSync = mutations.some(function (mutation) {
      return Array.from(mutation.addedNodes).some(function (node) {
        return node.nodeType === 1 && (
          node.matches?.('.product-form__submit, .price, .shopify-payment-button__button, .mt-payments-centered, .icon-with-text--horizontal, .rh-eta-pill, .rh-shipfree-pill, variant-selects, variant-radios') ||
          node.querySelector?.('.product-form__submit, .price, .shopify-payment-button__button, .mt-payments-centered, .icon-with-text--horizontal, .rh-eta-pill, .rh-shipfree-pill, variant-selects, variant-radios')
        );
      });
    });

    var mtNeedsProductEnhancements = mutations.some(function (mutation) {
      return Array.from(mutation.addedNodes).some(function (node) {
        return node.nodeType === 1 && (
          node.matches?.('.related-products__heading, product-recommendations') ||
          node.querySelector?.('.related-products__heading')
        );
      });
    });

    if (mtNeedsRefresh) mtInitializeTriggers();
    if (mtNeedsProductEnhancements) mtInitializeProductEnhancements();
    if (mtNeedsBuybarSync) {
      mtSyncMobileBuybar();
      mtInitializePurchaseArea();
      mtSyncProductStockState();
      mtInitializeDeliveryService();
    }
  });

  mtObserver.observe(document.body, { childList: true, subtree: true });
  mtInitializeTriggers();
  mtInitializeProductEnhancements();

  var mtPostedStatus = mtModal.querySelector('[data-mt-leasing-success], [data-mt-leasing-errors]');
  if (mtPostedStatus) {
    var mtFirstTrigger = document.querySelector('[data-mt-open-leasing]');
    if (mtFirstTrigger) mtOpen(mtFirstTrigger);
    mtWizardPreparePostedStatus(mtPostedStatus);
    window.requestAnimationFrame(function () {
      mtPostedStatus.focus?.();
    });
  }
})();
